import { Helmet } from "react-helmet";
import { Breadcrumbs, Divider, Link as MaterialLink, Typography } from "@material-ui/core";
import { Link, NavLink } from "react-router-dom";
import Button from "../Button";
import { ArrowBack } from "@material-ui/icons";

export default function PageHeader({
    pageTitle = '',
    title = '',
    extra,
    navs = [],
    className = '',
    backButtonTo = '',
    includeDivider = true
}) {

    return (
        <div>
            <div className={`flex justify-between items-center ${className}`}>
                <div className="shrink-0">
                    <Helmet title={pageTitle || title} />
                    <Typography variant="h4">
                        {backButtonTo ? (
                            <div className="flex gap-1 items-center">
                                <Link to={backButtonTo}>
                                    <Button
                                        type="text"
                                        icon={<ArrowBack className="translate-y-[1px]" />}
                                        className="!p-1 !rounded-full"
                                    >
                                    </Button>
                                </Link>
                                <div>{title}</div>
                            </div>
                        ) : title}
                    </Typography>

                    {!!navs.length && (
                        <div className={title ? "mt-2" : ''}>
                            <Breadcrumbs>
                                {navs.map((nav, index) => nav.href ? (
                                    <MaterialLink key={index} component={NavLink} exact to={nav.href}>
                                        {nav.label}
                                    </MaterialLink>
                                ) : (
                                    <div>{nav.label}</div>
                                ))}
                            </Breadcrumbs>
                        </div>
                    )}
                </div>

                {extra}
            </div>
            {!!includeDivider &&
                <div className="my-4">
                    <Divider />
                </div>
            }
        </div>
    )
}